import { create } from "zustand";

const playerEquipmentsStore = create((set, get) => ({
  playerEquipments: {}, // Lưu trữ tất cả các player và equipments của họ

  // Cập nhật một equipments trong một player cụ thể
  updateSingleEquipment: (playerId, idCfg, value) => {
    if (get().playerEquipments[playerId] == null) return;
    if (value === get().playerEquipments[playerId][idCfg]) {
      return;
    }
    set((state) => (
      {
        playerEquipments: {
          ...state.playerEquipments,
          [playerId]: {
            ...state.playerEquipments[playerId], // Giữ lại các equipments cũ
            [idCfg]: value, // Cập nhật equipments cụ thể
          },
        },
      }))
  },

  // Cập nhật toàn bộ Equipment của một player
  updatePlayerEquipment: (playerId, newEquipment) =>
    set((state) => ({
      playerEquipments: {
        ...state.playerEquipments,
        [playerId]: newEquipment, // Cập nhật toàn bộ equipments của player
      },
    })),

  // Cập nhật nhiều player cùng lúc
  updateMultiplePlayers: (newEquipment) =>
    set((state) => ({
      playerEquipments: {
        ...state.playerEquipments,
        ...newEquipment, // Merge với equipments hiện tại
      },
    })),
}));

export default playerEquipmentsStore;
